export default __webpack_public_path__ + "static/media/kubernetes.63b4f18b.svg";